import { Button } from 'antd';
import styled from 'styled-components';

export const StyledTitle = styled(Button)`
  font-weight: 600;
  font-size: 20px;
  padding-left: 0;
`;
